var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"root_container"}},[(_vm.isAuthenticated && _vm.isLogoLoaded)?_c('router-view'):_vm._e(),_c('toaster')],1)}
var staticRenderFns = []

export { render, staticRenderFns }